export default class Staff {
	constructor (data) {
		Object.assign(this, data)
		this.active = !!this.active
	}
}



// WEBPACK FOOTER //
// ./src/classes/Staff.js